export default __webpack_public_path__ + "static/media/joshua.dbed4ead.png";